export const ADMIN_API_NEWS_URL = '/admin/materials/';
export const ADMIN_API_NEWS_KEY = 'admin_news_select';

export const ADMIN_API_NEWS_HISTORY_URL = '/admin/history/';
export const ADMIN_API_NEWS_HISTORY_KEY = 'admin_news_history_select';
